module.exports = __webpack_public_path__ + "static/media/inktoberPinecone.d2e87d49.gif";